import React from 'react'
import ReporteCamionesEnPlayaIngreso from '../../../ReporteCamiones/containers/reportes/ReporteCamionesEnPlayaIngreso'
import ReporteCamionesAPlayaCalado from '../../../ReporteCamiones/containers/reportes/ReporteCamionesAPlayaCalado'
import EdicionCalleCamionCalado from './EdicionCalleCamionCalado'
import ReporteCamionesListosParaBruto from '../../../ReporteCamiones/containers/reportes/ReporteCamionesListosParaBruto'

function ReportesCamionesEgresoQR (props) {
  const { camionesEnPlaya, cpaEntrePlayaCalado, ceaCallesCaladoEgreso, cortesPedidos, camListosParaBruto } = props

  return (
    <div style={{ marginTop: '18px' }}>
      { (camionesEnPlaya && camionesEnPlaya.filas_procesadas > 0) && <ReporteCamionesEnPlayaIngreso
        camionesEnPlaya={camionesEnPlaya}
      />
      }
      {(cpaEntrePlayaCalado && cpaEntrePlayaCalado.length > 0) && <ReporteCamionesAPlayaCalado
        cpaEntrePlayaCalado={cpaEntrePlayaCalado}
        cortesPedidos={cortesPedidos}
      />
      }

      { camListosParaBruto && camListosParaBruto.length > 0 &&
      <ReporteCamionesListosParaBruto
        camListosParaBruto={camListosParaBruto}
        titulo='Camiones egresados'
      />
      }

      {(ceaCallesCaladoEgreso !== null) && (ceaCallesCaladoEgreso.length > 0) && <EdicionCalleCamionCalado /> }

    </div>
  )
}

export default ReportesCamionesEgresoQR
